import React from 'react';
import { string, func, bool, array } from 'prop-types';
import { FlexContainer, Box, Row, Checkbox, Text, Column, Divider } from '../../common';
import { GREEN_DARK, WHITE } from '../../../utils/colors';

const CardRow = ({ label, value }) => (
    <Row>
        <Column>
            <Text text={label} semibold />
        </Column>
        <Column flex={3}>
            <Text text={value} />
        </Column>
        <Divider />
    </Row>
);

CardRow.propTypes = {
    label: string,
    value: string
};

CardRow.defaultProps = {
    label: '',
    value: ''
};

const Card = ({ ean, user, lastModifiedDate, onCheck, allSelected }) => {
    return (
        <Box width={['90%', '50%', '25%']}>
            <FlexContainer
                backgroundColor={WHITE}
                margin={7}
                flex={1}
                padding={16}
                borderRadius={4}
                boxShadow
                direction='column'
            >
                <Row align='center'>
                    <Column noFlex>
                        <Checkbox defaultChecked={allSelected} onChange={onCheck} />
                    </Column>
                    <Column>
                        <Text text={ean} strong color={GREEN_DARK} size={16} />
                    </Column>
                </Row>
                <CardRow label='Creador' value={user} />
                <CardRow label='Fecha' value={lastModifiedDate} />
            </FlexContainer>
        </Box>
    );
};

Card.propTypes = {
    ean: string,
    user: string,
    lastModifiedDate: string,
    onCheck: func,
    allSelected: bool
};

export default Card;
